<template>
  <div>
    <!-- {{filterPayload}} -->
    <!-- <pre>{{studentAttendanceList}}</pre> -->
    <vs-card class="cstm_vx_card">
      <div slot="header">
        <h4 v-if="!$route.params.clientObject">All Teacher List</h4>
      </div>

      <div
        slot="header"
        class="flex items-center mb-4"
        v-if="$route && $route.params && $route.params.clientObject"
      >
        <vs-button
          type="border"
          @click="$router.push({ name: 'attendanceTeacher' }).catch(() => {})"
          icon="chevron_left"
        ></vs-button>

        <img
          style="width: 40px; height: 40px"
          class="rounded-full shadow-md block ml-2"
          v-if="$route.params.clientObject.picture"
          :src="$route.params.clientObject.picture"
          alt="image"
        />
        <img
          style="width: 40px; height: 40px"
          class="rounded-full shadow-md block ml-2"
          v-else
          src="http://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/user_image.png"
          alt="image"
        />
        <a style="font-weight: 600" class="ml-2">
          <!-- asdadasdasdad -->
          <span v-if="$route.params.clientObject.first_name"
            >{{ $route.params.clientObject.first_name }}
          </span>
          <span v-if="$route.params.clientObject.middle_name"
            >{{ $route.params.clientObject.middle_name }}
          </span>
          <span v-if="$route.params.clientObject.last_name">{{
            $route.params.clientObject.last_name
          }}</span>
        </a>
      </div>

      <ag-grid-vue 
        ref="agGridTable"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :style="{ minHeight: studentAttendanceList.length * 48 + 75 + 'px' }"
        :gridOptions="gridOptions"
        :animateRows="true"
        :floatingFilter="false"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :columnDefs="studentAttendanceListColumnDefs"
        :rowData="studentAttendanceList"
        @grid-ready="onGridReady"
      />
      <div class="sm:flex justify-between items-center">
        <ItemsPerTableDropdown
          tableName="teacher_attendance_list"
          @change="(pageLimit) => pageLimitSet = pageLimit"
        />
        <pagination
          :meta="attendance_meta"
          @page-change="handlePageChange"
          class="cstm_pagination"
          style="float: right"
        />
      </div>
    </vs-card>
  </div>
</template>

<script>
import { fetchTeacheAttendance } from '@/api/dashboard.js'


import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
import TeacherAttendanceNameCell from '../table_components/TeacherAttendanceNameCell.vue'
import AttendanceCell from '../table_components/AttendanceCell.vue'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { attendanceMixin } from '../mixins/attendanceMixin'
import Pagination from '@/components/common/pagination'
import { markAttendenceTeacher } from '@/api/calenderAction.js'

export default {
  mixins: [attendanceMixin, PermissionMiddleware],
  props: {
    filterPayload: {
      type: Object,
      required: true
    }
  },
  components: {
    AgGridVue,
    TeacherAttendanceNameCell,
    AttendanceCell,
    Pagination
  },
  data () {
    return {
      customer_id:localStorage.getItem('customer_id'),
      studentAttendanceList: [],
      studentAttendanceListColumnDefs: [],
      pageLimitSet: null,
      gridOptions: {},
      gridApi: null,
      attendance_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      }
    }
  },
  created () {
    this.fetchSingle()
  },
  mounted () {
    if (!this.$route.params.clientObject) {
      this.studentAttendanceListColumnDefs.push(
        {
          headerName: 'Teacher Name',
          field: 'teacher_name',
          cellRendererFramework: Vue.extend(TeacherAttendanceNameCell)
        }
      )
    }

    this.studentAttendanceListColumnDefs.push(
      {
        headerName: 'Course Name',
        field: 'course_name',
        valueFormatter: params => params.data.course != null ? params.data.course.name : ''
      },
      {
        headerName: 'Date',
        field: 'schedule_date',
        valueFormatter: params => this.$options.filters.dateFormatLocalization(params.data.schedule_date)
      },
      {
        headerName: 'Time',
        field: 'time',
        valueFormatter: params => `${this.$options.filters.OnlytimeFormatLocalization(params.data.schedule_from_time)} - ${this.$options.filters.OnlytimeFormatLocalization(params.data.schedule_to_time)}`
      },
      {
        headerName: 'Attendance',
        field: 'attendance',
        minwidth: 200,
        maxWidth: 200,
        cellRendererFramework: Vue.extend(AttendanceCell),
        CellRendererParams: {
          leavingMouse: (data) => this.leavingMouse(data),
          //edit_permission: () => this.edit_permission(),
          markingAttendance: (a, b, c, d) => this.markingAttendance(a, b, c, d),
          editAttendance: (data) => this.editAttendance(data)
        }
      }
    )

  },
  methods: {
    handlePageChange (page) {
      if (!this.pageLimitSet) return
      this.attendance_meta.current_page = page
      this.fetchSingle()
    },
    leavingMouse (attendanceInfo) {
      if (
        typeof attendanceInfo.attendance === 'boolean' &&
        !attendanceInfo.attendance_marked
      ) {
        attendanceInfo.attendance_marked = true
      }
    },
    presenCheck () {
    },
    editAttendance (attendanceInfo) {
      attendanceInfo.attendance_marked = false
    },
    delayedFunc (index) {
      index.delayed_input = false
    },
    async fetchSingle () {
      try {
        this.$vs.loading({ text: 'Fetching Attendance List' })
        const payload = {
          start_date: this.$moment(this.filterPayload.start_date).format(
            'YYYY-MM-DD'
          ),
          end_date: this.$moment(this.filterPayload.end_date).format(
            'YYYY-MM-DD'
          ),
          course_id: this.filterPayload.course_id,
          user_id: this.filterPayload.user_id || null,
          search: this.filterPayload.search || ''
        }
        this.attendance_meta.limit = this.pageLimitSet
        const { data } = await fetchTeacheAttendance(
          this.customer_id,
          payload,
          this.attendance_meta
        )
        this.studentAttendanceList = data.data.teachers
        this.attendance_meta = data.data.meta
        //this.mergeAttendace(data.data.users, data.data.attendance)

        // this.structuredStandardList(attendanceList)
        //
      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    mergeAttendace (studentList, attendance) {
      const alreadyAttendanceGiven = attendance.map((ele) => {
        return {
          ...ele,
          attendance_id: ele.id,
          attendance_marked: true,
          schedule_date: [this.$moment(ele.attendance_date).format('YYYY-MM-DD')]
        }
      })

      let notGiven = []
      //checking for singleStudent And If Single Student Is there then need to do the client Side
      if (!this.$route.params.clientObject) {
        notGiven = studentList.map((ele) => {
          return {
            ...ele,
            attendance_id: null,
            attendance: null,
            delay_in_minutes: null,
            attendance_marked: false
          }
        })
      } else {
        notGiven = this.eachStudentNotMarkedData(studentList, attendance).map(
          (ele) => {
            return {
              ...ele,
              attendance_id: null,
              attendance: null,
              delay_in_minutes: null,
              attendance_marked: false
            }
          }
        )
      }
      if (this.filterPayload.attendance_type === 'Marked') {
        this.studentAttendanceList = [...alreadyAttendanceGiven]
      } else if (this.filterPayload.attendance_type === 'UnMarked') {
        this.studentAttendanceList = [...notGiven]
      } else {
        this.studentAttendanceList = [...alreadyAttendanceGiven, ...notGiven]
      }

      const students = []
      for (let i = 0; i < this.studentAttendanceList.length; i++) {
        if (this.studentAttendanceList[i].schedule_date.length > 1) {
          for (
            let j = 0;
            j < this.studentAttendanceList[i].schedule_date.length;
            j++
          ) {
            students.push({
              ...this.studentAttendanceList[i],
              schedule_date: this.studentAttendanceList[i].schedule_date[j],
              schedule_from_time: [this.studentAttendanceList[i].schedule_from_time[j]],
              schedule_to_time: [this.studentAttendanceList[i].schedule_to_time[j]],
              schedule_id: [this.studentAttendanceList[i].schedule_id[j]]
            })
          }
        } else {
          students.push({
            ...this.studentAttendanceList[i],
            schedule_date: this.studentAttendanceList[i].schedule_date[0]
          })
        }
      }
      this.studentAttendanceList = students
    },
    eachStudentNotMarkedData (studentList, attendanceList) {
      const student = []
      const attendanceGivenCombination = attendanceList.map((ele) => {
        return `${ele.client_user_id}@${ele.course_id}@${ele.schedule_id}`
      })


      for (let i = 0; i < studentList.length; i++) {
        const ele = studentList[i]
        for (let j = 0; j < ele.schedule_date.length; j++) {
          const eachScheduleDate = ele.schedule_date[j]
          const stringChecking = `${ele.client_user_id}@${ele.course_id}@${ele.schedule_id[j]}`

          const eachScheduleDate1 = new Date(
            `${eachScheduleDate  } ${  ele.schedule_to_time[j]}`
          )
          const start_date1 = new Date(
            `${this.filterPayload.start_date  } 00:00:00`
          )
          const end_date1 = new Date(`${this.filterPayload.end_date  } 23:59:59`)

          if (
            this.$moment(this.$moment(eachScheduleDate1)).isBetween(
              this.$moment(start_date1),
              this.$moment(end_date1)
            )
          ) {
            if (!attendanceGivenCombination.includes(stringChecking)) {
              student.push({
                ...ele,
                schedule_date: [eachScheduleDate],
                schedule_from_time: [ele.schedule_from_time[j]],
                schedule_id: [ele.schedule_id[j]],
                schedule_to_time: [ele.schedule_to_time[j]]
              })
            }
          }
        }
      }
     

      return student
    },
    async structuredStandardList (studentList) {
      return studentList.map((ele) => {
        return {
          attendance_id: null,
          id: ele.user_id,
          attendance: true,
          delay_in_minutes: 0,
          name: `${ele.first_name} ${ele.last_name}`,
          picture: `${ele.picture}`
        }
      })
    },
    markingAttendance (attendanceObject, type, event) {
      const payload = {
        course_id: attendanceObject.course_id,
        attendance_date: this.$route.params.clientObject
          ? attendanceObject.schedule_date
          : this.filterPayload.start_date,
        teachers: [
          {
            teacher_id: attendanceObject.user_id,
            attendance: attendanceObject.attendance,
            delay_in_minutes: attendanceObject.delay_in_minutes
          }
        ],
        schedule_id: attendanceObject.id,
        unique_id: attendanceObject.unique_id,
      }

      if (type === 'delayed') {
        if (
          attendanceObject.delay_in_minutes > 1 &&
          attendanceObject.delay_in_minutes <= 120
        ) {
          if (
            event &&
            'keyCode' in event &&
            event.keyCode === 13 &&
            type === 'delayed'
          ) {
            attendanceObject.attendance_marked = true
          }
          this.submitAttendance(payload)
        } else {
          this.showSuccessMessage(
            'Error',
            'Attendance must be between 1 And 120',
            'danger'
          )
        }
      } else {
        this.submitAttendance(payload)
      }
    },
    async submitAttendance (payload) {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const res = await markAttendenceTeacher(customer_id, payload)
        if (res.status === 201) {
          this.showSuccessMessage(
            'Success',
            "Attendance marked successfully",
            'success'
          )
        }
      } catch (error) {
        console.log(error)
      }
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    }
  },
  directives: {},
  watch: {
    pageLimitSet () {
      this.handlePageChange(1)
    },
    filterPayload: {
      deep: true,
      handler () {
        this.fetchSingle()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>